import { produce } from "immer"
import types, { CommunityState } from "./types"

export const initialState: CommunityState = Object.freeze({
  communities: [],
  communitiesContentOwnership: {
    functions: [],
  },
  loading: false,
  filters: {
    functionValue: undefined,
    countryValues: undefined,
    levelValues: undefined,
  },
})

export default function reducer(state = initialState, action: { type: string; payload: any }) {
  return produce(state, (writableState) => {
    switch (action.type) {
      case types.FETCH_COMMUNITIES.REQUEST:
        writableState.loading = true
        writableState.error = false
        break
      case types.FETCH_COMMUNITIES.SUCCESS:
        writableState.communities = action.payload?.communities || []
        writableState.communitiesContentOwnership =
          action.payload?.communitiesContentOwnership || []
        writableState.loading = false
        writableState.error = false
        break
      case types.FETCH_COMMUNITIES.FAILURE:
        writableState.loading = false
        writableState.error = true
        break
      case types.SET_FILTER_VALUE:
        writableState.filters[action.payload.filterName as keyof CommunityState["filters"]] =
          action.payload.filterValue
        break
      default:
        return writableState
    }
    return writableState
  })
}
